import React, { useEffect, useState } from 'react';
import MainBody from './body';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { IoIosArrowBack } from "react-icons/io";
import { PiDotsThreeLight } from "react-icons/pi";
import { URLS } from '../../../Services/Urls';
import {API} from '../../../Services/axios'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setProjectData } from '../../../Redux/Store/Slices/projectReducer';
import { toast } from 'react-toastify';


//const fetcher = url => API.get(url).then(res => res.data)



const StructureContent = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  let { projetId } = useParams();
  const project = useSelector((state) => state.project);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  // const { data: proj, error, isValidating } = useSWR(URLS.PROJECT.details(projetId));

  // Define steps and sections based on project data
  const steps = project?.steps || [];

  // Handle click on sidebar links
  const handleStepClick = (index) => {
    setActiveStep(index);
  };

  const formatProjectType = (type) => {
    return type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      
      await API.put(URLS.PROJECT.details(project.id), project);
      
      // Affiche une notification de succès
      toast.success("Projet sauvegardé avec succès !");
      
      // Rediriger vers la page des projets après 1.5 secondes
      setTimeout(() => {
        navigate('/project');
      }, 1500);
      
    } catch (error) {
      // Affiche une notification d'erreur
      toast.error("Erreur lors de la sauvegarde du projet.");
      console.log("erreur :", error);
    } finally {
      setIsSaving(false);
    }
  };

  //const {project_type} = useSelector((state) => state.project);

  // if (error) return <div>Error loading data...</div>;
  // if (!project && isValidating) return <div>Loading...</div>;

  useEffect(() => {

    API.get(URLS.PROJECT.details(projetId)).then((resp) => {
      console.log("pdofof", resp.data);
      dispatch(setProjectData(resp.data));
    });

  }, []);

  useEffect(() => {
    console.log("Ce projet:", project);
  }, [project]);

  return (
    <>
      <div className='container-fluid bg-white overflow-hidden'>
        <div className='bg-colo border border-bottom'>
          <div className="d-flex justify-content-between border-btm px-4 shadow" style={{ height: '80px' }}>
            <div>
              <button type="button" className=" mt-4 bg-black-50  border-0 rounded" style={{ height: '40px', width:'40px '}}>
                <Link className="arrow-back-color fw-bold" to="/project">
                  <IoIosArrowBack />
                </Link>
              </button>
            </div>
            <div className="text-center mt-4 pt-2 fw-bold w-50">
              <p className="text-center text">{formatProjectType(project.project_type)} </p>
            </div>
            <div className="">
              <button button type="button p-5" className="p-3 mt-4 bg-black-50 border border-0 rounded three-light" style={{ height: '40px', width:'40px '}}>
                <PiDotsThreeLight />
              </button>
              <button 
                type="button" 
                className="btn button-btn" 
                onClick={handleSave}
                disabled={isSaving}
              >
                {isSaving ? 'Enregistrement...' : 'Save'}
              </button>
            </div>
          </div>
        </div>

        <div className="d-flex">
          <div className="border-right bg-color shadow" style={{ width: '327px' }}>
            <div className="">
              <div className="mt-5">
                <div>
                  {Array.isArray(steps) && (
                    <div>
                      <ul>
                        {project.steps.map((step, index) => (
                          <li
                            className="mt-1 fw-bold pt-3 text-color"
                            key={step.id}
                            onClick={() => handleStepClick(index)}
                            style={{
                              background: activeStep === index ? '#544A43' : 'transparent',
                              cursor: 'pointer',
                              width: '320px',
                              height: '48px',
                            }}
                          >
                            <span
                              className="p-tag"
                              style={{
                                background: activeStep === index ? '#fff' : 'transparent',
                                width: '4px',
                                height: '48px',
                              }}
                            ></span>
                            <span className="text-uppercase text-center px-4">
                              <Link
                                className={`step-text ${activeStep === index ? 'text-white' : '#544A43'}`}
                                to="#"
                              >
                                {step.name}
                              </Link>
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="p-5 border-black-top" style={{ position: 'relative', top: '80px' }}>
            <div>
              <h3 className="fw-bold text-capitalize">{steps[activeStep]?.name || 'Essense'}</h3>
              <p className="p-text">
                Start putting together your course by creating sections, lectures and practice (quizzes, coding exercises and assignments).<br />
                If you’re intending to offer your course for free, the total length of video content must be less than 2 hours.
              </p>
            </div>
            <div>
              <MainBody  sections={steps[activeStep]?.sections || []} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StructureContent;
